import { useEffect } from 'react';
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { getCookie } from 'utils/Cookie';

const App = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL || '';

  useEffect(() => {
    const token = getCookie('token');
    if (token && window.location.pathname === '/login') {
      window.location.replace(`${baseUrl}/dashboard`);
    } else if (!token && window.location.pathname !== '/login') {
      window.location.replace(`${baseUrl}/login`);
    }
  }, []);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <Routes />
      </ScrollTop>
    </ThemeCustomization>
  );
};

export default App;
